import Vue from 'vue'
import VueRouter from 'vue-router'

import { exists as existeItemLocal, get as getItemLocal, remove as removeItemLocal, localStorageKey } from '@/plugins/localStorage/index.js';
import { decrypt as decryptToken } from '@/plugins/JWT/index.js';

import { Store } from '@/plugins/store/index.js'

import LoginViews from '@/views/Login-views.vue';
import HomeViews from '@/views/Home-views.vue';
import NoAccessViews from '@/views/No-access-views.vue';
import SettingViews from '@/views/Setting-views.vue'
import UserMaintainerViews from '@/views/User-maintainer-views.vue'
import DocumentRepositoryViews from '@/views/Document-repository-views.vue'
import MeetingViews from '@/views/Meeting-views.vue'
import DenounceViews from '@/views/Denounce-views.vue';
import DenounceAnonymousViews from '@/views/Denounce-anonymous-views.vue'
import StatementsViews from '@/views/Statements-views.vue'
import ManagedCompaniesViews from "@/views/Managed-companies-views.vue";
// import SuppliersViews from '@/views/Suppliers-views.vue'
// import RrhhViews from '@/views/Rrhh-views.vue'
// import BriefcaseViews from '@/views/Briefcase-views.vue'
import TrainingViews from "@/views/Training-views.vue";
import CoursesContent from '@/components/Training/Courses-content.vue';
import CourseDetails from '@/components/Training/Course-details.vue';
import BoardViews from '@/views/Board-views.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Login',
        component: LoginViews,
        meta: { requiredAuth: false }
    },
    {
        path: '/NoAccess',
        name: 'NoAccess',
        component: NoAccessViews,
        meta: { requiredAuth: false }
    },
    {
        path: '/Home',
        name: 'Home',
        component: HomeViews,
        meta: { requiredAuth: true, requiredPermission: 'dashboard-vista' }
    },
    {
        path: '/Setting',
        name: 'Setting',
        component: SettingViews,
        meta: { requiredAuth: true, requiredPermission: 'configuracion-vista'}
    },
    {
        path: '/UserMaintainer',
        name: 'UserMaintainer',
        component: UserMaintainerViews,
        meta: { requiredAuth: true, requiredPermission: 'usuarios-vista'}
    },
    {
        path: '/DocumentRepository',
        name: 'DocumentRepository',
        component: DocumentRepositoryViews,
        meta: { requiredAuth: true, requiredPermission: 'documentos-vista' }
    },
    {
        path: '/Meeting',
        name: 'Meeting',
        component: MeetingViews,
        meta: { requiredAuth: true, requiredPermission: 'reuniones-vista' }
    },
    {
        path: '/Statements',
        name: 'Statements',
        component: StatementsViews,
        meta: { requiredAuth: true, requiredPermission: 'declaraciones-vista' }
    },
    // {
    //     path: '/Suppliers',
    //     name: 'Suppliers',
    //     component: SuppliersViews,
    //     meta: { requiredAuth: true }
    // },
    // {
    //     path: '/Rrhh',
    //     name: 'Rrhh',
    //     component: RrhhViews,
    //     meta: { requiredAuth: true }
    // },
    // {
    //     path: '/Briefcase',
    //     name: 'Briefcase',
    //     component: BriefcaseViews,
    //     meta: { requiredAuth: true }
    // },
    {
        path: '/Denounce',
        name: 'Denounce',
        component: DenounceViews,
        meta: { requiredAuth: true }
    },
    {
        path: '/DenounceAnonymous',
        name: 'DenounceAnonymous',
        component: DenounceAnonymousViews,
        meta: { requiredAuth: false }
    },
    {
        path: '/ManagedCompanies',
        name: 'ManagedCompanies',
        component: ManagedCompaniesViews,
        meta: { requiredAuth: true, requiredPermission: 'empresas-vista' }
    },
    {
        path: '/Training',
        component: TrainingViews,
        meta: { requiredAuth: true, requiredPermission: 'capacitaciones-vista' },
        children: [
            {
                path: '',
                name: 'CoursesContent',
                component: CoursesContent
            },
            {
                path: ':courseId',
                name: 'Course',
                component: CourseDetails,
                props: true
            },
        ]
    },
    {
        path: '/Board',
        name: 'Board',
        component: BoardViews,
        meta: {
            requiredAuth: true
        }
    },
];

const Router = new VueRouter({
    routes: routes,
    mode: 'history'
})

Router.beforeEach((to, from, next) => {
    //si no tiene restriccion de permisos que entre
    if (!to.matched.some(record => record.meta.requiredAuth)) {
        next();
        return;
    }

    //si no existe el token en storage entonces no entre
    else if (!existeItemLocal(localStorageKey.tokenKey)) {
        next({ name: 'NoAccess' })
        return;
    }

    //si existe el token, etermine si el token esta correcto
    let token = getItemLocal(localStorageKey.tokenKey)
    let tokenDecrypt = decryptToken(token);
    if (tokenDecrypt.isError) {
        removeItemLocal(localStorageKey.tokenKey);
        next({ name: 'NoAccess' })
        return;
    }

    //si existe le token y esta bien entonces lo volvemos a cargar a la session
    Store.commit('modifySession', {
        userId: tokenDecrypt.data.UserId,
        username: tokenDecrypt.data.Username,
        mail: tokenDecrypt.data.mail,
        exp: tokenDecrypt.data.exp
    });


    //si los permisos no estan cargados enviar al login
    if (!existeItemLocal(localStorageKey.permissionKey)) {
        next({ name: 'NoAccess' })
        return;
    }

    //si estan cargados los permisos entonces guardarlos en el estorage
    let permisos = getItemLocal(localStorageKey.permissionKey)
    Store.commit('modifyPermissions', permisos);

    if (!to.matched.every(record => {
        if ('requiredPermission' in record.meta) {
            return permisos.includes(record.meta.requiredPermission);
        }
        return true
    })) {
        next({ name: Store.getters.getHomePath })
        return
    }

    //si el rol no estan cargados enviar al login
    if (!existeItemLocal(localStorageKey.roleKey)) {
        next({ name: 'NoAccess' })
        return;
    }

    //si estan cargado el rol entonces guardarlos en el estorage
    let rol = getItemLocal(localStorageKey.roleKey)
    Store.commit('modifyRole', rol);

    //si cumple con todo que entre
    next();
});

['push', 'replace'].forEach(method => {
    const originalMethod = Router[method];
    Router[method] = function m(location) {
        return originalMethod.call(this, location).catch(error => {
            if (error.name == 'NavigationDuplicated') {
                //navegacion duplicada no hago nada
            }
        })
    };
});

export default Router;
